module.exports = __webpack_public_path__ + "static/media/Funshine.9c8715a5.mp3";